import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class UploadFileExpedienteService {

    constructor(
        private _httpClient: HttpClient
    ) {
    }

    /**
     * Post file
     * api/seaged-prestaciones-vinculacion/upload-excel-vinculacion
     * @param fileToUpload
     */
    public postFile(fileToUpload: FormData): Observable<any> {
        return this._httpClient.post(
            '/api/seaged-prestaciones-vinculacion/upload-excel-vinculacion',
            fileToUpload)
            .pipe(
                map(response => response)
            );
    }
}
